import "../../theme/mobileChrome.mjs";
import { styled as e } from "styled-components";
//#region src/components/Toolbar/StickyToolbar.tsx
var t = e.div`
    position: sticky;
    top: 0;
    z-index: 50;
    margin-left: -${({ theme: e }) => e.spacing(4)};
    margin-right: -${({ theme: e }) => e.spacing(4)};
    padding: ${({ theme: e }) => e.spacing(1.5, 4)};
    background: ${({ theme: e }) => e.colors.background}cc; /* ~80% opacity */
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    /* Sticks just under the opaque phone bar, not tucked beneath it. */
    @media (max-width: 1023px) {
        top: calc(${60}px + env(safe-area-inset-top, 0px));
    }
`;
//#endregion
export { t as StickyToolbar };
